// extracted by mini-css-extract-plugin
export default {"xSplit":"xSplit--PtV1k"};